<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Orion_receipt 1">
      <path
        id="layer2"
        d="M6.74925 18.7529H12.7492M6.74925 11.2529H12.7492M6.74925 15.7537H11.2492M6.74925 8.25218H11.2492M15.75 18.7529H17.2485M15.75 11.2529H17.2485M15.75 15.7537H17.2485M15.75 8.25218H17.2485"
        stroke="#214C9F"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M3.01013 22.498V1.50705L5.25225 3.0018L7.52625 1.50255L9.76763 3.0018L12.0176 1.50705M12.0176 1.50705L14.2594 3.0018L16.5086 1.50705M12.0176 1.50705V1.50255M16.5086 1.50705L18.7515 3.0018L21 1.50705V22.498M16.5086 1.50705V1.50255M0.75 22.498H23.25"
        stroke="#214C9F"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
